<template>
  <div>
    <h2>{{$t(title_group)}}</h2>
    <v-divider class="mx-2"></v-divider>
  </div>
</template>

<script>
export default {
    name: "TitleGroup",
    props: ['title_group'],
}
</script>